import { render } from "./searchExComponent.vue?vue&type=template&id=b8a9c416"
import script from "./searchExComponent.vue?vue&type=script&lang=js"
export * from "./searchExComponent.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__